import React from 'react'
import { Box, Text } from '@chakra-ui/react'
export default function Footer() {
    return (
        <>
            <Box w='100%' h='70px' mt={5} bgGradient='linear(to-l,#2193b0, #6dd5ed)' display={"flex"} alignItems={"center"} justifyContent={"center"} flexDirection={"column"}>
                <Text fontSize={"sm"}>&copy; {new Date().getFullYear()} Aryamitra Chaudhuri | v2.0</Text>
                <Text fontSize={"xs"}>Last updated 28.11.2022</Text>
            </Box>
        </>
    )
}
